import moment from 'moment'
export default {
    //过滤器格式化时间
    formats(value,formatter){
        let times = value*1000
        times = moment(times).format(formatter);
        return times
    },
    //资源状态过滤器
    zySate(value){
        switch (value) {
            case 0:
                return '待审核';
            case 1:
                return '审核通过';
            case 2:
                return '审核不通过';
            default :
                return '全部'
        }
    },
    //资源状态颜色过滤器
    zySatestyle(value){
        switch (value) {
            case '待审核':
                return 'stateStyle';
            case '审核通过':
                return 'stateStyleG';
            case '审核不通过':
                return 'stateStyleR';
            default :
                return ''
        }
    },
    // 数字。字母转化
    change(val){
        switch (val) {
            case 0:
                return val = 'A'
                break;
            case 1:
                return val = 'B'
                break;
            case 2:
                return val = 'C'
                break;
            case 3:
                return val= 'D'
                break;
            case 4:
                return val = 'E'
                break;
            case 5:
                return val = 'F'
                break;
            default:
                break;
        }
    }
}
